export default {"src":"/_next/static/media/personal.c4ae9e02.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};